
// Quantity "plus" and "minus" buttons
$(document.body).on('click', '.plus, .minus', function () {
    const qty = $(this).closest('.quantity-field').find('.qty')
    let currentVal = parseFloat(qty.val())
    let max = parseFloat(qty.attr('max'))
    let min = parseFloat(qty.attr('min'))
    let step = qty.attr('step')

    // Format values
    if (!currentVal || currentVal === '' || currentVal === 'NaN') currentVal = 0
    if (max === '' || max === 'NaN') max = ''
    if (min === '' || min === 'NaN') min = 0
    if (step === 'any' || step === '' || step === undefined || parseFloat(step) === 'NaN') step = 1

    // Change the value
    if ($(this).is('.plus')) {
    if (max && (currentVal >= max)) {
        qty.val(max)
    } else {
        qty.val((currentVal + parseFloat(step)).toFixed(getDecimals(step)))
    }
    } else {
    if (min && (currentVal <= min)) {
        qty.val(min)
    } else if (currentVal > 0) {
        qty.val((currentVal - parseFloat(step)).toFixed(getDecimals(step)))
    }
    }

    // Trigger change event
    qty.trigger('change')

})

function getDecimals(num) {
    const match = num.toString().match(/(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/);
    
    if (!match) {
      return 0;
    }
  
    const decimalPartLength = match[1] ? match[1].length : 0;
    const exponentAdjustment = match[2] ? +match[2] : 0;
  
    return Math.max(0, decimalPartLength - exponentAdjustment);
}